<template>
  <div v-loading="loading">
    <div class="title">出题任务</div>
    <div>
      <el-input
        class="w-150 mb-12 mr-12"
        placeholder="抽检任务"
        prefix-icon="el-icon-search"
        v-model.trim="search.name"
        size="medium"
        clearable
      >
      </el-input>
      <el-select
        class="w-150 mr-12"
        v-model="search.stack_id"
        size="medium"
        filterable
        remote
        reserve-keyword
        clearable
        placeholder="关联技能点"
        prefix-icon="el-icon-search"
        :remote-method="remoteStack"
        :loading="selectLoading"
      >
        <el-option
          v-for="point in skill_points"
          :key="point.id"
          :label="point.name"
          :value="point.id"
        ></el-option>
      </el-select>
      <el-select
        class="w-120 mr-12"
        v-model="search.status"
        clearable
        @change="search"
        placeholder="状态"
        size="medium"
      >
        <el-option label="未开始" :value="1"></el-option>
        <el-option label="抽检中" :value="2"></el-option>
        <el-option label="已结束" :value="3"></el-option>
      </el-select>
      <el-button type="primary" size="medium" plain @click="getData"
        >查询</el-button
      >
      <el-button size="medium" @click="clearSearch">重置</el-button>
    </div>
    <el-table :data="list" :stripe="true">
      <el-table-column width="100" label="编号" prop="id"></el-table-column>
      <el-table-column label="抽检任务" prop="name"></el-table-column>
      <el-table-column width="150" label="任务截止时间">
        <template slot-scope="scope">
          <div v-if="scope.row.end_date">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{ scope.row.end_date }}</span>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>

      <el-table-column
        width="110"
        label="技能点"
        prop="stack.stack_name.name"
      ></el-table-column>
      <el-table-column width="110" label="状态" prop="required_total_number">
        <template slot-scope="scope">
          {{ statusList[scope.row.status - 1] }}
        </template>
      </el-table-column>
      <el-table-column
        width="110"
        label="抽检进度"
        prop="required_total_number"
      >
        <template slot-scope="scope">
          {{
            ((scope.row.checked_number * 100) / scope.row.number).toFixed(2) +
              "%"
          }}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        v-if="
          authPermissions.includes(
            'question.api.fuwu_admin.skill_question_spot_check.tasks.questions.show'
          )
        "
        width="70"
        label="操作"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.status == 3">已完成</div>
          <el-link
            type="primary"
            v-else
            :underline="false"
            @click="assignTopic(scope.row)"
            >去抽检</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      @current-change="getData"
      :current-page.sync="pagination.currentPage"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      :hide-on-single-page="true"
    >
    </el-pagination>
    <SpotPreviewAudit
      :batchVisible.sync="batchVisible"
      :taskInfo="taskInfo"
      v-if="batchVisible"
      @clearBatchInfo="getData"
    >
    </SpotPreviewAudit>
  </div>
</template>

<script>
import { mapState } from "vuex";
import codeService from "@/global/service/code";
import skillService from "@/global/service/skill";
import SpotPreviewAudit from "./widgets/SpotPreviewAudit.vue";
export default {
  components: { SpotPreviewAudit },
  data() {
    return {
      loading: true,
      selectLoading: false,
      search: {
        stack_id: null,
        name: null,
        status: null
      },
      skill_points: [],
      list: [],
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      batchVisible: false,
      statusList: ["未开始", "进行中", "已结束"],
      taskId: null,
      taskName: null,
      taskNumber: null
    };
  },
  computed: {
    ...mapState(["authPermissions"])
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const params = {
        page: this.pagination.currentPage,
        page_size: this.pagination.pageSize,
        stack_id: this.search.stack_id,
        name: this.search.name,
        status: this.search.status
      };
      this.loading = true;
      skillService
        .skillSpotCheckList(params)
        .then(res => {
          this.list = res.list;
          this.pagination.currentPage = Number(res.pagination.current_page);
          this.pagination.total = Number(res.pagination.total);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    assignTopic(data) {
      this.taskInfo = data;
      this.batchVisible = true;
    },
    clearSearch() {
      this.search = {
        stack_id: null,
        name: null,
        status: null
      };
      this.getData();
    },
    remoteStack(query) {
      if (query !== "") {
        this.selectLoading = true;
        codeService
          .kcellSkills({ name: query })
          .then(res => {
            this.skill_points = res;
          })
          .finally(() => {
            this.selectLoading = false;
          });
      } else {
        this.skill_points = [];
      }
    }
  }
};
</script>

<style lang="less">
.skill-task-dialog {
  .el-dialog__header,
  .el-dialog__body {
    padding: 0;
  }
}
</style>
<style lang="less" scoped>
.search-box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}
.hidden-redundant {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  &:hover {
    color: #409eff;
  }
}
.toggle-show {
  cursor: pointer;
  .toggle-show-icon {
    margin-left: 4px;
  }
  &:hover {
    color: #409eff;
  }
}
</style>
